import { useState } from 'react';
import './File.css';
type FileProps = { file: FileObject }

function File(props: FileProps) {
  const [previewIsClosed, setPreviewIsClosed] = useState(true)
  const previewButton =
    <button onClick={() => setPreviewIsClosed(!previewIsClosed)}>
      {previewIsClosed ? "Preview" : "Close"}
    </button>;
  const navigation = props.file.status == "working" ? "処理中" :
                     props.file.status == "error" ? "CYOファイルではありません" :
                     previewButton

  return (
    <>
      <p>
        {props.file.name}: {navigation}
      </p>
      {!previewIsClosed && <pre>{props.file.preview}</pre>}
    </>
  );
}

export default File;
